export default "__VITE_PUBLIC_ASSET__04842165__"